import styled from 'styled-components'

export const DropdownBackground = styled.div`
  background-color: white;
  width: fit-content;
  z-index: 9999;

  min-width: ${props => props.theme.dropdown.minWidth};
  padding: ${props => props.theme.dropdown.padding};
  border: ${props => props.theme.dropdown.border};
  border-radius: ${props => props.theme.dropdown.borderRadius};
  box-shadow: ${props => props.theme.dropdown.boxShadow};
`
